import { render } from "./CollapsibleTR.vue?vue&type=template&id=91216bfe&scoped=true"
import script from "./CollapsibleTR.vue?vue&type=script&lang=js"
export * from "./CollapsibleTR.vue?vue&type=script&lang=js"

import "./CollapsibleTR.vue?vue&type=style&index=0&id=91216bfe&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91216bfe"]])

export default __exports__